import React from "react";
import Breadcrumb from "@/components/Breadcrumb";
import SEO from "@/components/SEO";
import ToolCard from "@/components/ToolCard";
import { useFavorites } from "@/context/FavoritesContext";
import { useI18n } from "@/context/I18nContext";
import { TOOLS } from "@/data/tools";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { favorites } = useFavorites();
  const { t } = useI18n();
  const tools = TOOLS.filter((x) => favorites.includes(x.slug));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SEO title="Favorites — ImageKitHub" description="Your favorite image tools, pinned for quick access." />
      <Breadcrumb items={[{ label: t("nav.favorites") }]} />
      <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">
        {t("favorites.title")}
      </h1>
      <p className="mt-2 text-slate-500 dark:text-slate-400">{t("favorites.subtitle")}</p>

      {tools.length === 0 ? (
        <div className="mt-14 p-16 rounded-2xl border-2 border-dashed border-slate-200 dark:border-white/10 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-slate-100 dark:bg-white/5 text-slate-400 grid place-items-center">
            <Heart size={22} />
          </div>
          <p className="mt-5 text-slate-500 dark:text-slate-400 max-w-md mx-auto">{t("favorites.empty")}</p>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {tools.map((t2, i) => <ToolCard key={t2.slug} tool={t2} index={i} />)}
        </div>
      )}
    </div>
  );
}
